import {
  cloneDeep
} from "lodash";
import { extractWidth, processImageUrl } from "@/util/pic"
import Message from "@/components/Message";

/** 焦点卡片新增时 数据格式化 */
export const formatAddFocus = (data) => {
  const cloneData = cloneDeep(data);
  const ids = [cloneData.thirdPartyApps];
  cloneData.thirdPartyApps = []
  ids.forEach(item => {
    cloneData.thirdPartyApps.push({
      id: item
    })
  })
  /** 如果是失效 */
  if (cloneData.status === 0) {
    cloneData.effectMode = null
  }
  /** 如果指定有效时间 */
  if (cloneData.effectMode === 2) {
    cloneData.effectStartTime = cloneData.effectTime[0]
    cloneData.effectEndTime = cloneData.effectTime[1]
  } else {
    cloneData.effectStartTime = null
    cloneData.effectEndTime = null
  }
  delete cloneData.effectTime

  /** 24-0325-0新增跳转链接 */
  delete cloneData.link

  delete cloneData.imgWidth
  delete cloneData.imgSelectWidth
  return cloneData
};

/** 专题卡片新增时 数据格式化 */
export const formatAddSubject = (data) => {
  const cloneData = cloneDeep(data);
  const ids = cloneData.items.map(item => item.id)
  cloneData.items = ids
  /** 如果是失效 */
  if (cloneData.status === 0) {
    cloneData.effectMode = null
  }
  /** 如果指定有效时间 */
  if (cloneData.effectMode === 2) {
    cloneData.effectStartTime = cloneData.effectTime[0]
    cloneData.effectEndTime = cloneData.effectTime[1]
  } else {
    cloneData.effectStartTime = null
    cloneData.effectEndTime = null
  }
  delete cloneData.effectTime

  /** 2024-07-03 限制图片宽度 */
  delete cloneData.imgWidth
  delete cloneData.imgSelectWidth
  return cloneData
};

/** 导航卡片新增时 数据格式化 */
export const formatAddNavForm = (data) => {
  const cloneData = cloneDeep(data);
  /** 如果是失效 */
  if (cloneData.status === 0) {
    cloneData.effectMode = null
  }
  /** 如果指定有效时间 */
  if (cloneData.effectMode === 2) {
    cloneData.effectStartTime = cloneData.effectTime[0]
    cloneData.effectEndTime = cloneData.effectTime[1]
  } else {
    cloneData.effectStartTime = null
    cloneData.effectEndTime = null
  }
  delete cloneData.effectTime

  /* 2024-07-03 限制图片宽度 */
  delete cloneData.imgWidth
  delete cloneData.imgSelectWidth
  return cloneData
};

/** 榜单卡片新增时 数据格式化 */
export const formatAddListForm = (data) => {
  const cloneData = cloneDeep(data);
  /** 如果是失效 */
  if (cloneData.status === 0) {
    cloneData.effectMode = null
  }
  /** 如果指定有效时间 */
  if (cloneData.effectMode === 2) {
    cloneData.effectStartTime = cloneData.effectTime[0]
    cloneData.effectEndTime = cloneData.effectTime[1]
  } else {
    cloneData.effectStartTime = null
    cloneData.effectEndTime = null
  }
  delete cloneData.effectTime
  /** 频道列表 */
  cloneData.tabIds = cloneData.channelItems.map(item => item.id)
  delete cloneData.channelItems
  return cloneData
};

/** 直播卡片新增时 数据格式化 */
export const formatAddLiveForm = (data) => {
  const cloneData = cloneDeep(data);
  const ids = cloneData.items.map(item => item.id)
  cloneData.items = ids
  /* 2024-07-08 限制图片宽度 */
  delete cloneData.imgWidth
  delete cloneData.imgSelectWidth

  /** 如果是失效 */
  if (cloneData.status === 0) {
    cloneData.effectMode = null
  }
  /** 如果指定有效时间 */
  if (cloneData.effectMode === 2) {
    cloneData.effectStartTime = cloneData.effectTime[0]
    cloneData.effectEndTime = cloneData.effectTime[1]
  } else {
    cloneData.effectStartTime = null
    cloneData.effectEndTime = null
  }
  delete cloneData.effectTime

  return cloneData
};

/** 追剧投屏卡片新增时 数据格式化 */
export const formatAddEpisForm = (data) => {
  const cloneData = cloneDeep(data);

  /** 如果是失效 */
  if (cloneData.status === 0) {
    cloneData.effectMode = null
  }
  /** 如果指定有效时间 */
  if (cloneData.effectMode === 2) {
    cloneData.effectStartTime = cloneData.effectTime[0]
    cloneData.effectEndTime = cloneData.effectTime[1]
  } else {
    cloneData.effectStartTime = null
    cloneData.effectEndTime = null
  }
  delete cloneData.effectTime
  return cloneData
};

/** 内容卡片新增时 数据格式化 */
export const formatAddContent = (data) => {
  const cloneData = cloneDeep(data);
  const ids = cloneData.items.map(item => item.id)
  cloneData.items = ids
  /** 如果是失效 */
  if (cloneData.status === 0) {
    cloneData.effectMode = null
  }
  /** 如果指定有效时间 */
  if (cloneData.effectMode === 2) {
    cloneData.effectStartTime = cloneData.effectTime[0]
    cloneData.effectEndTime = cloneData.effectTime[1]
  } else {
    cloneData.effectStartTime = null
    cloneData.effectEndTime = null
  }
  delete cloneData.effectTime
  return cloneData
};

/** 内容横滑卡片新增时 数据格式化 */
export const formatAddSlide = (data) => {
  const cloneData = cloneDeep(data);
  const ids = cloneData.items.map(item => item.id)
  cloneData.items = ids
  /** 如果是失效 */
  if (cloneData.status === 0) {
    cloneData.effectMode = null
  }
  /** 如果指定有效时间 */
  if (cloneData.effectMode === 2) {
    cloneData.effectStartTime = cloneData.effectTime[0]
    cloneData.effectEndTime = cloneData.effectTime[1]
  } else {
    cloneData.effectStartTime = null
    cloneData.effectEndTime = null
  }
  delete cloneData.effectTime
  return cloneData
};

//^ ^--------------编辑相关-------------^ ^

/** 焦点卡片编辑时 数据格式化 */
export const formatEditFocus = (data) => {
  const cloneData = cloneDeep(data);
  const id = cloneData.thirdPartyApps[0].id;
  cloneData.thirdPartyApps = id
  /** 如果是指定时间生效 -> 组装指定时间 */
  if (cloneData.effectMode && cloneData.effectMode === 2) {
    cloneData.effectTime = [cloneData.effectStartTime, cloneData.effectEndTime]
  }
  delete cloneData.recommendMedias

  /** 24-0325-0新增跳转链接 */
  cloneData.link = ''

  /** 24-07-01新增图片填写宽度 */
  const width = extractWidth(cloneData.coverImg)
  if (['300', '700'].includes(width)) {
    cloneData.imgSelectWidth = width
    cloneData.imgWidth = ''
  } else {
    /** 如果是旧的图片会找不到宽度 那么就默认选择300 */
    if (!width) {
      cloneData.imgSelectWidth = '300'
    } else {
      cloneData.imgSelectWidth = -1
      cloneData.imgWidth = width
    }
  }
  return cloneData
};

/** 专题卡片编辑时 数据格式化 */
export const formatEditSubject = (data) => {
  const cloneData = cloneDeep(data);
  const items = cloneData.recommendMedias.map(item => item)
  cloneData.items = items
  /** 如果是指定时间生效 -> 组装指定时间 */
  if (cloneData.effectMode && cloneData.effectMode === 2) {
    cloneData.effectTime = [cloneData.effectStartTime, cloneData.effectEndTime]
  }
  delete cloneData.thirdPartyApps
  delete cloneData.recommendMedias

  /** 24-07-01新增图片填写宽度 */
  const width = extractWidth(cloneData.coverImg)
  if (['300', '700'].includes(width)) {
    cloneData.imgSelectWidth = width
    cloneData.imgWidth = ''
  } else {
    /** 如果是旧的图片会找不到宽度 那么就默认选择300 */
    if (!width) {
      cloneData.imgSelectWidth = '300'
    } else {
      cloneData.imgSelectWidth = -1
      cloneData.imgWidth = width
    }
  }
  return cloneData
};

/** 导航卡片编辑时 数据格式化 */
export const formatEditNav = (data) => {
  const cloneData = cloneDeep(data);
  cloneData.thirdPartyApps = cloneData.thirdPartyApps.map(item => {
    return {
      id: item.id,
      displayDescription: item.displayDescription
    }
  })
  /** 如果是指定时间生效 -> 组装指定时间 */
  if (cloneData.effectMode && cloneData.effectMode === 2) {
    cloneData.effectTime = [cloneData.effectStartTime, cloneData.effectEndTime]
  }
  delete cloneData.recommendMedias

  /** 24-07-01新增图片填写宽度 */
  const width = extractWidth(cloneData.coverImg)
  if (['300', '700'].includes(width)) {
    cloneData.imgSelectWidth = width
    cloneData.imgWidth = ''
  } else {
    /** 如果是旧的图片会找不到宽度 那么就默认选择300 */
    if (!width) {
      cloneData.imgSelectWidth = '300'
    } else {
      cloneData.imgSelectWidth = -1
      cloneData.imgWidth = width
    }
  }
  return cloneData
};

/** 榜单卡片编辑时 数据格式化 */
export const formatEditList = (data) => {
  const cloneData = cloneDeep(data);
  /** 如果是指定时间生效 -> 组装指定时间 */
  if (cloneData.effectMode && cloneData.effectMode === 2) {
    cloneData.effectTime = [cloneData.effectStartTime, cloneData.effectEndTime]
  }
  delete cloneData.thirdPartyApps
  delete cloneData.recommendMedias
  /** 频道列表 */
  cloneData.channelItems = cloneData.tabs.map((item) => {
    item.contentList = item.medias
    item.cardId = item.id
    delete item.medias
    return item
  })
  delete cloneData.tabList
  return cloneData
};

/** 直播卡片编辑时 数据格式化 */
export const formatEditLive = (data) => {
  const cloneData = cloneDeep(data);
  const items = cloneData.recommendMedias.map(item => item)
  cloneData.items = items
  /** 24-07-08新增图片填写宽度 */
  const width = extractWidth(cloneData.coverImg)
  if (['300', '700'].includes(width)) {
    cloneData.imgSelectWidth = width
    cloneData.imgWidth = ''
  } else {
    /** 如果是旧的图片会找不到宽度 那么就默认选择300 */
    if (!width) {
      cloneData.imgSelectWidth = '300'
    } else {
      cloneData.imgSelectWidth = -1
      cloneData.imgWidth = width
    }
  }
  /** 如果是指定时间生效 -> 组装指定时间 */
  if (cloneData.effectMode && cloneData.effectMode === 2) {
    cloneData.effectTime = [cloneData.effectStartTime, cloneData.effectEndTime]
  }
  delete cloneData.thirdPartyApps
  delete cloneData.recommendMedias
  return cloneData
};

/** 追剧投屏卡片编辑时 数据格式化 */
export const formatEditEpis = (data) => {
  const cloneData = cloneDeep(data);
  cloneData.thirdPartyApps = cloneData.thirdPartyApps.map(item => {
    return {
      id: item.id,
      displayStatus: item.displayStatus
    }
  })
  /** 如果是指定时间生效 -> 组装指定时间 */
  if (cloneData.effectMode && cloneData.effectMode === 2) {
    cloneData.effectTime = [cloneData.effectStartTime, cloneData.effectEndTime]
  }
  delete cloneData.recommendMedias
  return cloneData
};

/** 内容卡片编辑时 数据格式化 */
export const formatEditContent = (data) => {
  const cloneData = cloneDeep(data);
  const items = cloneData.recommendMedias.map(item => item)
  cloneData.items = items
  /** 如果是指定时间生效 -> 组装指定时间 */
  if (cloneData.effectMode && cloneData.effectMode === 2) {
    cloneData.effectTime = [cloneData.effectStartTime, cloneData.effectEndTime]
  }
  delete cloneData.thirdPartyApps
  delete cloneData.recommendMedias
  return cloneData
};

/** 内容横滑卡片编辑时 数据格式化 */
export const formatEditSlide = (data) => {
  const cloneData = cloneDeep(data);
  const items = cloneData.recommendMedias.map(item => item)
  cloneData.items = items
  /** 如果是指定时间生效 -> 组装指定时间 */
  if (cloneData.effectMode && cloneData.effectMode === 2) {
    cloneData.effectTime = [cloneData.effectStartTime, cloneData.effectEndTime]
  }
  delete cloneData.thirdPartyApps
  delete cloneData.recommendMedias
  return cloneData
};


//^ ^--------------频道相关-------------^ ^
/** 榜单卡片频道新增时 数据格式化 */
export const formatAddListChannel = (data) => {
  const cloneData = cloneDeep(data);
  cloneData.recommendMediaIds = cloneData.contentList.map(item => item.id)
  return cloneData
};

//^ ^--------------通用方法-------------^ ^
/** 校验图片宽度 */
export const validateImageWidth = (form) => {
  const data = cloneDeep(form)
  const { imgSelectWidth, imgWidth } = data;

  // 校验图片宽度是否填写
  if (imgSelectWidth === -1 && !imgWidth) {
    Message.error('请输入图片宽度');
    return false;
  }

  // 校验宽度格式 (正整数) 范围是1-1000
  if (imgWidth && !/^(?:[1-9][0-9]{0,2}|1[0-8][0-9]{2}|19[01][0-9]|1920)$/.test(imgWidth)) {
    Message.error('请输入1-1920的正整数的图片宽度');
    return false;
  }

  return true;
}

/** 根据图片宽度更新图片url */
export const updateImgUrl = (form) => {
  const data = cloneDeep(form)

  const { imgSelectWidth, imgWidth, coverImg } = data;
  const width = imgSelectWidth === -1 ? imgWidth : imgSelectWidth;
  data.coverImg = processImageUrl(coverImg, width);

  return data
}